export default {
    // Example getter
    getAuthEmployee(state) {
        // return some derived state
        return state.employee;
    }
    // ... add other getters as needed
};